import { SxProps, Theme } from '@mui/material/styles';

// Container styles
export const containerBoxSx: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(3),
  marginBottom: theme.spacing(2),
});

export const headingSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(1),
  fontWeight: 600,
});

export const descriptionSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.text.secondary,
});

// Formula box styles
export const formulaContainerSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(2),
});

export const formulaLabelSx = (error: string, theme: Theme): SxProps<Theme> => ({
  marginBottom: theme.spacing(0.5),
  color: error ? theme.palette.error.main : theme.palette.text.secondary,
});

export const formulaBoxSx = (error: string, theme: Theme): SxProps<Theme> => ({
  minHeight: '80px',
  padding: theme.spacing(1.5),
  border: `1px solid ${error ? theme.palette.error.main : theme.palette.divider}`,
  borderRadius: theme.spacing(0.5),
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
});

export const errorTextSx: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.error.main,
  marginTop: theme.spacing(0.5),
  display: 'block',
});

// Number editor styles
export const numberEditorContainerSx: SxProps<Theme> = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
});

export const numberEditorLabelSx: SxProps<Theme> = () => ({
  fontWeight: 500,
});

export const numberEditorTextFieldSx: SxProps<Theme> = () => ({
  width: '100px',
  '& .MuiInputBase-root': {
    height: '32px',
  },
});

// Chip styles
export const chipSx: SxProps<Theme> = () => ({
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.8,
  },
});

// Metric editor popover styles
export const metricEditorContainerSx = (rect: DOMRect): SxProps<Theme> => ({
  position: 'fixed',
  left: `${rect.left}px`,
  top: `${rect.bottom - 40}px`,
  zIndex: 1300,
});

export const metricEditorHiddenBoxSx: SxProps<Theme> = () => ({
  opacity: 0,
  pointerEvents: 'none',
  height: 0,
  width: 0,
  overflow: 'hidden',
});

// Operator popover styles
export const operatorListSx: SxProps<Theme> = () => ({
  minWidth: 200,
  py: 0,
});

export const operatorListItemButtonSx: SxProps<Theme> = () => ({
  py: 0.5,
});

// Controls section styles
export const controlsContainerSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(2),
});

export const controlsLabelSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(0.5),
  color: theme.palette.text.secondary,
});

export const controlsBoxSx: SxProps<Theme> = (theme: Theme) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  flexWrap: 'wrap',
});

export const insertNumberTextFieldSx: SxProps<Theme> = () => ({
  width: '150px',
});

export const addButtonSx: SxProps<Theme> = () => ({
  minWidth: '80px',
  color: 'black',
  borderColor: 'black',
});

export const tooltipWrapperSx: SxProps<Theme> = () => ({
  display: 'inline-block',
});

export const operatorButtonSx: SxProps<Theme> = (theme: Theme) => ({
  minWidth: '40px',
  padding: theme.spacing(0.5, 1),
});

export const clearButtonContainerSx: SxProps<Theme> = () => ({
  marginLeft: 'auto',
});

export const clearButtonSx: SxProps<Theme> = () => ({
  textTransform: 'none',
});
